module.exports = __webpack_public_path__ + "img/TOP42024.eb2a25b9.png";